
// Add this to override.js at the top
// console.log('Override.js loaded');

// Color swatch variant switching
document.addEventListener('DOMContentLoaded', function() {
  // Handle color swatch clicks
  document.addEventListener('click', function(e) {
    const swatchLink = e.target.closest('.color-swatch-link, .variant-image-swatch-link');
    if (swatchLink) {
      e.preventDefault();

      const variantId = swatchLink.dataset.variantId;
      const colorName = swatchLink.dataset.color;

      if (variantId) {
        // Find the product form and variant selector
        const productForm = document.querySelector('product-form form, .product-form form');
        const variantSelector = document.querySelector('variant-selects');

        if (productForm && variantSelector) {
          // Update the variant ID in the form
          const variantIdInput = productForm.querySelector('[name="id"]');
          if (variantIdInput) {
            variantIdInput.value = variantId;
          }

          // Find and update the color option selector
          const colorSelectors = variantSelector.querySelectorAll('input[type="radio"], option');
          colorSelectors.forEach(selector => {
            if (selector.value && selector.value.toLowerCase() === colorName.toLowerCase()) {
              if (selector.type === 'radio') {
                selector.checked = true;
                selector.dispatchEvent(new Event('change', { bubbles: true }));
              } else if (selector.tagName === 'OPTION') {
                selector.selected = true;
                selector.closest('select').dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          });

          // Trigger variant change event
          const changeEvent = new CustomEvent('variant:change', {
            detail: { variantId: variantId, color: colorName }
          });
          document.dispatchEvent(changeEvent);

          // Update URL without reload
          const url = new URL(window.location);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url);
        } else {
          // Fallback: navigate to variant URL
          window.location.href = swatchLink.href;
        }
      }
    }
  });
});

// Announcement bar js for close the bar and onsame click also adjust teh banner height to increase 
const announcementWrapper = document.getElementById("announcement-svg-wrapper");
if (announcementWrapper) {
  announcementWrapper.addEventListener("click", function () {
    const utilityBar = document.querySelector(".utility-bar"); // Select the utility-bar
    if (utilityBar) {
      utilityBar.setAttribute("hidden", "true"); // Add the hidden attribute
      sessionStorage.setItem("utilityBarHidden", "true"); // Store in sessionStorage

    }

    if (window.innerWidth <= 768) { // Adjust this breakpoint as needed
      const banner = document.querySelector(".hero-banner");
      if (banner) {
        banner.style.height = "80vh";
      }
    }
    if (window.innerWidth > 768) { // Adjust this breakpoint as needed
      const banner = document.querySelector(".hero-banner");
      if (banner) {
        banner.style.height = "80rem";
      }
    }
   
  });
}

// Add this to see if elements exist
// console.log('Mega menus found:', document.querySelectorAll('.mega-menu').length);
// header js for hover mega menu
document.querySelectorAll('.mega-menu').forEach((details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.mega-menu__content');
    
    // Only proceed if both summary and content exist
    if (summary && content) {
      let isHovered = false;
      // Open the dropdown when the mouse enters the summary or the content
      const openDropdown = () => {
        isHovered = true;
        details.setAttribute('open', '');
           };
    
      // Close the dropdown when the mouse leaves both the summary and the content
      const closeDropdown = () => {
        isHovered = false;
        setTimeout(() => {
          if (!isHovered) {
            details.removeAttribute('open');
          }
        }, 100); // Slight delay to handle quick transitions
      };
    
      summary.addEventListener('mouseenter', openDropdown);
      summary.addEventListener('mouseleave', closeDropdown);
    
      content.addEventListener('mouseenter', openDropdown);
      content.addEventListener('mouseleave', closeDropdown);
    }
    // js for close the mobile menu - handle multiple instances
    function setupMobileMenuClose() {
      // Use querySelectorAll to find ALL mobile menu close buttons
      const mobileMenuCloseButtons = document.querySelectorAll('#mobile-menu-close');
      console.log('Mobile menu close buttons found:', mobileMenuCloseButtons.length);
      
      if (mobileMenuCloseButtons.length > 0) {
        mobileMenuCloseButtons.forEach((button, index) => {
          console.log(`Setting up mobile menu close button ${index + 1}`);
          
          // Remove any existing listeners first
          button.removeEventListener("click", handleMobileMenuClose);
          button.removeEventListener("mousedown", handleMobileMenuClose);
          
          // Add event listeners
          button.addEventListener("click", handleMobileMenuClose);
          button.addEventListener("mousedown", handleMobileMenuClose);
        });
        
        console.log('Mobile menu close event listeners added to all buttons');
        return true;
      }
      return false;
    }
    
    function handleMobileMenuClose(e) {
      console.log('Mobile menu close triggered:', e.type);
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Find the closest menu drawer container for this specific button
      const clickedButton = e.target;
      let menuDrawer = clickedButton.closest('header-drawer')?.querySelector('#Details-menu-drawer-container');
      
      // If not found in closest header-drawer, try to find any open menu drawer
      if (!menuDrawer) {
        const allMenuDrawers = document.querySelectorAll('#Details-menu-drawer-container');
        for (let drawer of allMenuDrawers) {
          if (drawer.hasAttribute('open')) {
            menuDrawer = drawer;
            break;
          }
        }
      }
      
      console.log('Menu drawer found:', !!menuDrawer);
      
      if (menuDrawer) {
        const menuSummary = menuDrawer.querySelector("summary");
      
        // Remove the "open" attribute
        if (menuDrawer.hasAttribute("open")) {
          menuDrawer.removeAttribute("open");
          console.log('Menu drawer closed');
        }
      
        // Update "aria-expanded" attribute
        if (menuSummary) {
          menuSummary.setAttribute("aria-expanded", "false");
        }
        
        // Remove overflow hidden class
        if (document.body.classList.contains("overflow-hidden-tablet")) {
          document.body.classList.remove("overflow-hidden-tablet");
        }
      } else {
        // Fallback: Close ALL open menu drawers
        console.log('No specific menu drawer found, closing all open drawers');
        const allMenuDrawers = document.querySelectorAll('#Details-menu-drawer-container[open]');
        allMenuDrawers.forEach(drawer => {
          drawer.removeAttribute("open");
          const summary = drawer.querySelector("summary");
          if (summary) {
            summary.setAttribute("aria-expanded", "false");
          }
        });
        
        if (document.body.classList.contains("overflow-hidden-tablet")) {
          document.body.classList.remove("overflow-hidden-tablet");
        }
      }
    }
    
    // Try immediately
    if (!setupMobileMenuClose()) {
      // If not found, try with timeout
      setTimeout(() => {
        if (!setupMobileMenuClose()) {
          // If still not found, use MutationObserver to watch for DOM changes
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'childList') {
                if (setupMobileMenuClose()) {
                  observer.disconnect();
                }
              }
            });
          });
          
          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        }
      }, 100);
    }
    
    // Also add a global click handler as a fallback for any mobile menu close buttons
    document.addEventListener('click', function(e) {
      if (e.target && e.target.id === 'mobile-menu-close') {
        console.log('Global mobile menu close handler triggered');
        handleMobileMenuClose(e);
      }
    });
  });

  document.addEventListener("click", function (event) {
    const detailsMenuDrawer = document.getElementById("Details-menu-drawer-container");
    const menuDrawer1 = document.getElementById("menu-drawer");
  
    // Ensure `Details-menu-drawer-container` has the `open` attribute
    if (detailsMenuDrawer && detailsMenuDrawer.hasAttribute("open")) {
      // Check if the click is outside `menu-drawer`
      if (menuDrawer1 && !menuDrawer1.contains(event.target)) {
        // Remove the "overflow-hidden-tablet" class from <body> if present
        if (document.body.classList.contains("overflow-hidden-tablet")) {
          document.body.classList.remove("overflow-hidden-tablet");
        }
      }
    }
  });
  
  // accordion js
  document.addEventListener('DOMContentLoaded', () => {
    // Target all .product__accordion containers
    const accordions = document.querySelectorAll('.product__accordion');
    // const collapsible_row = document.querySelectorAll('.collapsible-content');
    // Loop through each accordion for product page PDP
    accordions.forEach(accordion => {
        const detailsElement = accordion.querySelector('details');
        const plusIcon = detailsElement.querySelector('.plus-icon');
        const minusIcon = detailsElement.querySelector('.minus-icon');
        const updateIcon = () => {
            const isOpen = detailsElement.hasAttribute('open');
            if (isOpen) {
                plusIcon.style.display = 'none'; // Hide plus icon
                minusIcon.style.display = 'inline-block'; // Show minus icon
            } else {
                plusIcon.style.display = 'inline-block'; // Show plus icon
                minusIcon.style.display = 'none'; // Hide minus icon
            }
        };
        updateIcon();
        detailsElement.addEventListener('toggle', updateIcon);
    });
});

// select product dropdown js
document.addEventListener('DOMContentLoaded', () => {
  const selectToggle = document.querySelector('.select-toggle');
  const selectMenu = document.querySelector('.select__menu');
  // const hiddenInput = document.getElementById('selected-option'); // Reference to the hidden input field
  const displayTarget = document.getElementById('selected-value-display'); // Target element for displaying the value
  const svgwrap = document.querySelectorAll(".svg-wrapper");
  // const addToBagButton = document.querySelector('.product-form__submit'); // Button selector

  // Only proceed if required elements exist
  if (selectToggle && selectMenu) {

  // Function to update the URL
  function updateURL(url, variantId) {
    window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
  }

  // Simple function to update variant without page reload
  function updateVariantWithoutReload(variantId) {
    // Just update the form input - this is the most important part
    const productForm = document.querySelector('product-form');
    if (productForm) {
      const hiddenInput = productForm.querySelector('input[type="hidden"][name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variantId;
        console.log('Updated variant ID to:', variantId);
      }
    }
    
    // Trigger a simple variant change event
    const variantChangeEvent = new CustomEvent('variant-change', {
      detail: { variantId: variantId }
    });
    document.dispatchEvent(variantChangeEvent);
  }

  selectToggle.addEventListener('click', () => {
    const isOpen = selectMenu.style.display === 'block';
    selectMenu.style.display = isOpen ? 'none' : 'block';
    selectToggle.setAttribute('aria-expanded', !isOpen);
    // svgwrap.style.transform = "rotate(180deg)";
     svgwrap.forEach(wrapper => {
    wrapper.style.transform = isOpen ? "rotate(0deg)" : "rotate(180deg)";
  });
  });

  document.addEventListener('click', (event) => {
    if (!selectToggle.contains(event.target) && !selectMenu.contains(event.target)) {
      selectMenu.style.display = 'none';
      selectToggle.setAttribute('aria-expanded', 'false');
    }
  });
  

  selectMenu.addEventListener('click', (event) => {
    const selectedItem = event.target.closest('.select__select__item');
    if (selectedItem) {
      event.preventDefault();
      const selectedValue = selectedItem.textContent.trim();
      const dataValue = selectedItem.getAttribute('data-value-id');
       // Check if the item is already selected (it should not be re-selected)
    const previouslySelectedItem = selectMenu.querySelector('.select__select__item[selected="selected"]');
    
    if (previouslySelectedItem) {
      // If another item is already selected, remove the 'selected' attribute
      previouslySelectedItem.removeAttribute('selected');
    }

    // Add the 'selected' attribute to the clicked item
    selectedItem.setAttribute('selected', 'selected');
    

      // Update the visible toggle text
      selectToggle.innerHTML = `${selectedValue}`;

      // Update the hidden input value
      // hiddenInput.value = selectedValue;

      // Locate the specific form to update
      const productForm = document.querySelector("product-form");
      if (productForm) {
        const currentForm = document.querySelector('.form'); // Replace with your form's unique ID or class
        if (currentForm) {
          // Find the hidden input inside the form and update its value
          const hiddenInput = currentForm.querySelector('input[type="hidden"][name="id"]');
          if (hiddenInput) {
            hiddenInput.value = dataValue; // Set the value to the data-value-id of the selected item
          }
        }
      }
          
      // Update the URL with the selected ID (variantId)
      const currentPath = window.location.pathname;
      updateURL(currentPath, dataValue); // Pass the selected ID to the URL updater
      if (displayTarget) {
        displayTarget.value = `${dataValue}`;
      }
      
      selectMenu.style.display = 'none';
      selectToggle.setAttribute('aria-expanded', 'false');

      // Try to update variant without reload, fallback to reload if needed
      try {
        updateVariantWithoutReload(dataValue);
      } catch (error) {
        console.error('Variant update failed, reloading page:', error);
        location.reload();
      }
      
      // const target = event.target;
      // publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
      //   data: {
      //     event,
      //     target,
      //     selectedOptionValues: selectedOptionValues(),
      //   },
      // });
      
    }
  });
  }
});

// function getInputForEventTarget(target) {
//     return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
// }

function getInputForEventTarget(target) {
  // Ensure the target is an 'li' with the class 'select__select__item'
  if (target && target.classList.contains('select__select__item')) {
    // Check if the 'li' has the 'selected' attribute
    if (target.hasAttribute('selected')) {
      return target; // Return the item if it's selected
    }
  }

  // If not selected, return the target as it is
  return target;
}

function selectedOptionValues() {
	return Array.from(document.querySelectorAll('.select__menu .select__select__item[selected], fieldset input:checked')).map(
	  ({ dataset }) => dataset.valueId
	);
}

  // 
//   document.querySelector('.mobile-menu-drawer').addEventListener('click', function() {
//     // Toggle the 'open' attribute on click
//     const menuDrawer = this;
    
//     // If 'open' attribute exists, remove it; otherwise, add it
//     if (menuDrawer.getAttribute('open') !== null) {
//         menuDrawer.removeAttribute('open');
//     } else {
//         menuDrawer.setAttribute('open', '');
//     }
// });

document.addEventListener('DOMContentLoaded', () => {
  const triggerButton = document.getElementById('size-guide-trigger');
  const closeButton = document.getElementById('size-guide-close');
  const drawer = document.getElementById('size-guide-drawer');
  const overlay = document.getElementById('drawer-overlay');
  const size_dist = document.getElementsByClassName('product__info-wrapper')[0];

  // Only proceed if required elements exist
  if (triggerButton && closeButton && drawer && overlay && size_dist) {
    function removezandaddclass() {
      if (!size_dist.classList.contains("scroll-trigger")) {
        // Add the class if it does not exist
        size_dist.classList.add("scroll-trigger");
      }
      size_dist.style.zIndex = "";
      document.body.style.overflow = "";
    }
    
    // Open Drawer
    triggerButton.addEventListener('click', () => {
      drawer.classList.add('active');
      overlay.classList.add('active');
      if (size_dist.classList.contains("scroll-trigger")) {
        size_dist.classList.remove("scroll-trigger");
      }
      size_dist.style.zIndex = "9";
      document.body.style.overflow = "hidden";
    });

    // Close Drawer
    closeButton.addEventListener('click', () => {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
      removezandaddclass();
    });

    // Close Drawer by Clicking on Overlay
    overlay.addEventListener('click', () => {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
      removezandaddclass();
    });

    // Prevent clicks inside drawer from closing it
    drawer.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  }
});

// fix to the mobile menu drawer
// document.addEventListener('DOMContentLoaded', () => {
//   const menu_drawer = document.getElementsByClass('menu-drawer-container');
//   const head_r = document.getElementById('section-header.shopify-section-group-header-group');


//   if (menu_drawer.hasAttribute("open")) {
//     head_r.style.zIndex = '5'
//   }

//   });

//multicolumn scroll effect js
document.addEventListener("DOMContentLoaded", function () {
  function setImageWrapperMaxHeight() {
    document.querySelectorAll(".multicolumn-card__image-wrapper").forEach(function (imageWrapper) {
      const mediaElement = imageWrapper.querySelector(".media");
      if (mediaElement) {
        const mediaHeight = mediaElement.offsetHeight;
        imageWrapper.style.maxHeight = `${mediaHeight}px`; // Apply max-height dynamically
      }
    });
  }
  // Run function on page load and window resize
  setImageWrapperMaxHeight();
  window.addEventListener("resize", setImageWrapperMaxHeight);

  window.addEventListener("scroll", function () {
    const imageWrappers = document.querySelectorAll(".multicolumn-card__image-wrapper");

    imageWrappers.forEach(function (imageWrapper) {
      // Check if the .p-sticky class exists within the imageWrapper
      const stickyElement = imageWrapper.querySelector(".p-sticky");
      if (!stickyElement) return; // Skip this imageWrapper if .p-sticky doesn't exist

      const info = imageWrapper.querySelector(".multicolumn-card__info");
      if (!info) return; // Skip if .multicolumn-card__info doesn't exist

      const infoHeight = info.offsetHeight; // Height of the info block
      const imageWrapperRect = imageWrapper.getBoundingClientRect();
      const imageWrapperTop = imageWrapperRect.top; // Position of the top
      const imageWrapperBottom = imageWrapperRect.bottom; // Position of the bottom
      // const imageWrapperTop = imageWrapper.getBoundingClientRect().top; // Position relative to the viewport
    const buffer = 10; 
      // When the wrapper reaches or passes the top of the viewport
      if (imageWrapperTop <= infoHeight || imageWrapperBottom <= window.innerHeight + buffer) {
        info.style.position = "absolute";
        info.style.top = "auto"; // Keeps it aligned properly
      } else {
        // Reset to relative positioning if the wrapper is below the viewport
        info.style.position = "relative";
        info.style.top = "auto";
      }
    });
  });
});



// sticky-header-pdp js
const stickyHeader = document.getElementById('sticky-header-pdp');
const productInfoElements = document.getElementsByClassName("product-info-pdp");
const siteHeader = document.querySelector("header");
const sectionHeader = document.querySelector(".section-header"); // Reference to the section header
const buttonElement = document.querySelector('.for-pdp .product-form__buttons');

// Only proceed if sticky header exists
if (stickyHeader) {

// Function to check if an element is in the viewport
if (window.innerWidth <= 768) {
function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// Function to check visibility on scroll
function checkVisibilityOnScroll() {
  if (buttonElement && isInViewport(buttonElement)) {
    // alert("hello");
    stickyHeader.style.opacity = "0"; // Fade out
    stickyHeader.style.visibility = "hidden";
  }
  else{
    stickyHeader.style.visibility = "visible"; // Make it interactable
    stickyHeader.style.opacity = "1"; // Fade in
    stickyHeader.style.position = "fixed";
    stickyHeader.style.bottom = "0"; // Show from bottom
    stickyHeader.style.top = "auto"; // Remove top positioning
    stickyHeader.style.width = "100%";
    stickyHeader.style.zIndex = "1000"; // Higher z-index to ensure it's above other content
    stickyHeader.style.display = "flex";
  }
}

// Listen for the scroll event and trigger the check
window.addEventListener('scroll', checkVisibilityOnScroll);

// Initial check when the page loads
checkVisibilityOnScroll();
function scrollTobtn() {
    const element = document.querySelector('.product-form__buttons');

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

  };
 if(document.getElementById("ProductAnchorButton")) {
    document.getElementById("ProductAnchorButton").onclick = scrollToTop
  }
document.getElementById("ProductAnchorButton").onclick = scrollTobtn;

}

if (window.innerWidth > 768) {
  function handleScroll() {
    // Show sticky bar when ATC button scrolls out of viewport (same logic as mobile)
    if (buttonElement) {
      const btnRect = buttonElement.getBoundingClientRect();
      if (btnRect.bottom <= 0) {
        stickyHeader.style.visibility = "visible";
        stickyHeader.style.opacity = "1";
        stickyHeader.style.position = "fixed";
        stickyHeader.style.bottom = "0";
        stickyHeader.style.top = "auto";
        stickyHeader.style.width = "100%";
        stickyHeader.style.zIndex = "1000";
        stickyHeader.style.display = "flex";
      } else {
        stickyHeader.style.opacity = "0";
        stickyHeader.style.visibility = "hidden";
      }
    }
  }
  window.addEventListener("scroll", handleScroll);
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  if(document.getElementById("ProductAnchorButton")) {
    document.getElementById("ProductAnchorButton").onclick = scrollToTop
  }
}


// js for click on country selector button change the zindex value

// klavio functionality on trigger button
// Get all buttons with class 'triggerClick'
const triggerButtons = document.querySelectorAll('.triggerClick');
// Loop through each button and attach the event listener
triggerButtons.forEach(function(button) {
  button.addEventListener('click', function(event) {
    event.preventDefault(); // Prevent the default button behavior
    // Simulate a click on the .klaviyo-bis-trigger anchor
    const klaviyoTrigger = document.querySelector('.klaviyo-bis-trigger');
    if (klaviyoTrigger) {
      klaviyoTrigger.click(); // Simulate click
      
    }
  });
});


// pdp carousel close popup function
function closePopup() {
  const image_popup = document.getElementById("image-popup");
  if (image_popup) {
    image_popup.classList.add("hidden-pop");
  }
}
}
